module.exports = {
  USER_ROLES: {
    GUEST: 0,
    PROVIDER: 1,
    CUSTOMER: 2,
    ADMIN: 3,
  },
  BOOKING_STATUSES: {
    DRIVER_BOOKS: 1, // 'Driver makes booking',
    GARAGE_BOOKS: 2, // 'Garage makes booking OR garage confirms driver booking',
    GARAGE_DONE: 3, // 'Garage clicks work done',
    CLAIM_SUBMITED: 4, // 'Garage submits claim',
    // Fixed this typo in some SPs
    // @TODO Fix typo in all SPs
    CLAIM_SUBMITTED: 4, // 'Garage submits claim',
    CLAIM_APPROVED: 5, // 'WCFMC Authorises claim',
    DONE: 6, // 'WCFMC Changes claimPaid to 1 (booking closes)',
  },
  STATUSES: {
    CREATED: 1,
    ACCEPTED: 2,
    DECLINED: 3,
    STARTED: 4,
    COMPLETED: 5,
    FAILED: 6,
  },
  PAYMENT_TYPES: {
    UPFRONT: 1,
    MONTHLY: 2,
  },
};
